import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  obterTermoDeUsoGovBr,
  obterTermoDeUsoIdPositiva,
  postAssinarTermoDeUsoGovBr,
  postAssinarTermoDeUsoIdPositiva } from '../../api/profileAPI';

import { RootState } from '../../app/store';
import { MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA, MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB } from '../../common/Mensagens';
import { PessoaModel } from '../../model/Pessoa';

export interface TermoDeUsoState {
  buscandoTermo: boolean;
  temTermoAssinado: any;
  ativarMensagem: boolean;
  versaoMinimaAceitavel: boolean;
}

const initialState: TermoDeUsoState = {
  buscandoTermo: false,
  temTermoAssinado: undefined,
  ativarMensagem: false,
  versaoMinimaAceitavel: true

};

export const getTermoDeUsoIdPositiva = createAsyncThunk(
  'termoDeUso/getTermoDeUsoIdPositiva',
  async (pessoa: PessoaModel): Promise<any> => {
    return obterTermoDeUsoIdPositiva(pessoa);
  }
);

export const getTermoDeUsoGovBr = createAsyncThunk(
  'termoDeUso/getTermoDeUsoGovBr',
  async (cpf: string): Promise<any> => {
    return obterTermoDeUsoGovBr(cpf);
  }
);

export const assinarTermoDeUsoIdPositiva = createAsyncThunk(
  'termoDeUso/assinarTermoDeUsoIdPositiva',
  async (pessoa: PessoaModel) => {
    return postAssinarTermoDeUsoIdPositiva(pessoa);
  }
);

export const assinarTermoDeUsoGovBr = createAsyncThunk(
  'termoDeUso/assinarTermoDeUsoGovBr',
  async (cpf: string) => {
    return postAssinarTermoDeUsoGovBr(cpf);
  }
);

export const termoDeUsoSlice = createSlice({
  name: 'termoDeUso',
  initialState,
  reducers: {
    setBuscandoTermo: (state, action) => {
      state.buscandoTermo = action.payload;
    },
    resetTermoDeUso: state => {
      state.buscandoTermo = false;
      state.temTermoAssinado = initialState.temTermoAssinado;
      state.ativarMensagem = initialState.ativarMensagem;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTermoDeUsoIdPositiva.fulfilled, (state, action) => {
        state.buscandoTermo = false;
        state.temTermoAssinado = action.payload.termoDeUsoAssinado;
      })
      .addCase(getTermoDeUsoIdPositiva.rejected, (state, error) => {
        if (error.error?.message && (error.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA) ||
          error.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB))) {
          state.versaoMinimaAceitavel = false;
        }
        state.buscandoTermo = false;
        state.temTermoAssinado = false;
      })
      .addCase(getTermoDeUsoGovBr.fulfilled, (state, action) => {
        state.buscandoTermo = false;
        state.temTermoAssinado = action.payload.termoDeUsoAssinado;
      })
      .addCase(getTermoDeUsoGovBr.rejected, (state, error) => {
        if (error.error?.message && (error.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA) ||
          error.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB))) {
          state.versaoMinimaAceitavel = false;
        }
        state.buscandoTermo = false;
        state.temTermoAssinado = undefined;
      })
      .addCase(assinarTermoDeUsoIdPositiva.fulfilled, (state, action) => {
        state.temTermoAssinado = action.payload.termoDeUsoAssinado;
      })
      .addCase(assinarTermoDeUsoGovBr.fulfilled, (state, action) => {
        state.temTermoAssinado = action.payload.termoDeUsoAssinado;

        if (action.payload.termoDeUsoAssinado) {
          state.ativarMensagem = false;
        } else {
          state.ativarMensagem = true;
        }
      })
      .addCase(assinarTermoDeUsoGovBr.rejected, (state, error) => {
        state.temTermoAssinado = false;
        state.ativarMensagem = true;
      });
  },
});

export const { setBuscandoTermo, resetTermoDeUso } = termoDeUsoSlice.actions;
export const selectVersaoMinimaAceitavel = (state: RootState) => state.termoDeUso.versaoMinimaAceitavel;
export const selectTemTermoAssinado = (state: RootState) => state.termoDeUso.temTermoAssinado;
export const selectBuscandoTermo = (state: RootState) => state.termoDeUso.buscandoTermo;
export const selectStateTermoDeUso = (state: RootState) => state.termoDeUso;

export default termoDeUsoSlice.reducer;
